import { getApiOutgoingEmails } from 'reduxes/slices/api/selectors'
import { createSelector } from 'reselect'
import {getCurrentHandle} from "../current/selectors";

export const makeGetOutgoingEmails = () =>
  createSelector(
    [(_, props) => props.timelineId, getApiOutgoingEmails, getCurrentHandle],
    (timelineId, outgoingEmails, currentHandle) => {
      return Object.values(outgoingEmails).filter((oe) => {
        return oe.timeline_id === timelineId && oe.from_handle === currentHandle
      })
    },
  )
